package com.milta.core.localization.translations.ro

import com.milta.core.localization.AdminPromptsStrings

internal val AdminPrompts = AdminPromptsStrings(
    loading = "Se încarcă…",
    errorNoConnection = "Serverul nu poate fi contactat — verifică-ți conexiunea.",
    errorGeneric = "A apărut o eroare. Încearcă din nou mai târziu.",
    contractLockedNotice = "🔒 Contractul de ieșire (format JSON) rămâne blocat — este adăugat automat pe server după textul editat, pentru ca extragerea în producție să nu se defecteze niciodată.",
    notModifiedLabel = "Valoare implicită — niciodată modificată",
    modifiedOnPrefix = "Modificat pe",
    resetToDefaultAction = "↺ Resetează la valorile implicite",
    editableBodyLabel = "✏️ Conținut editabil — reguli de business",
    markdownBoldSnippet = "**text îngroșat**",
    markdownItalicSnippet = "*text italic*",
    markdownCodeSnippet = "`cod`",
    markdownHeadingSnippet = "## Titlu",
    markdownBulletSnippet = "- element listă",
    markdownNumberedSnippet = "1. element listă",
    markdownQuoteSnippet = "> citat",
    previewToggleEdit = "✏️ Editează",
    previewToggleShow = "👁 Previzualizare",
    contractFooterLabel = "🔒 Contract de ieșire — blocat, adăugat automat",
    actionErrorOffline = "Eșuat — verifică-ți conexiunea.",
    actionErrorGeneric = "Salvarea a eșuat, încearcă din nou.",
    unsavedChangesNotice = "● Modificări nesalvate",
    savingAction = "Se salvează…",
    saveAction = "Salvează modificările",
)
